import { motion } from "framer-motion";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import Logo from "../images/services/Logo - PNG - White.png";

const socials = [
  {
    Icon: FaFacebook,
    href: "https://www.facebook.com/p/ABC-School-Of-Music-100078738204747",
    label: "Facebook",
  },
  {
    Icon: FaInstagram,
    href: "https://www.instagram.com/abc_schoolofmusic/",
    label: "Instagram",
  },
  {
    Icon: FaYoutube,
    href: "https://www.youtube.com/@ABCSCHOOLOFMUSIC15",
    label: "YouTube",
  },
];

const quickLinks = [
  { name: "Home", href: "/" },
  { name: "Gallery", href: "/gallery" },
  { name: "Contact", href: "/contact-us" },
];

const Footer = () => {
  return (
    <footer className="bg-ink text-white">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          {/* Brand */}
          <div>
            <img
              src={Logo}
              alt="ABC School of Music"
              className="h-12 w-auto"
            />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-gray-400">
              Empowering your musical journey, one note at a time — through
              expert-led classes in the heart of Hyderabad.
            </p>
            <div className="mt-5 flex gap-3">
              {socials.map(({ Icon, href, label }) => (
                <motion.a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  whileHover={{ y: -3 }}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-lg text-white transition-colors hover:bg-brand hover:text-white"
                >
                  <Icon />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div className="md:justify-self-center">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-gray-400">
              Explore
            </h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-300 transition-colors hover:text-brand"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-gray-400">
              Visit Us
            </h3>
            <ul className="mt-4 space-y-4 text-sm text-gray-300">
              <li className="flex gap-3">
                <FaMapMarkerAlt className="mt-1 flex-none text-brand" />
                <span>
                  1st Floor, Plot No: 14A, Hi-Tension Rd, Eshwaripuri Colony,
                  Kapra, Hyderabad, Telangana 500062
                </span>
              </li>
              <li className="flex items-center gap-3">
                <FaPhoneAlt className="flex-none text-brand" />
                <a
                  href="tel:+919966908986"
                  className="transition-colors hover:text-brand"
                >
                  +91 99669 08986
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-sm md:flex-row">
          <span className="italic text-brand-300">
            "Empowering your musical journey, one note at a time."
          </span>
          <span className="text-gray-400">
            © {new Date().getFullYear()} ABC School of Music. All rights
            reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
